import React, { useEffect, useState } from "react";
import { CalendarCheck, Truck, Undo2, Bike, PackageCheck, Euro, TrendingUp, Loader2 } from "lucide-react";
import api from "../../lib/api";

const Stat = ({ icon: Icon, label, value, accent }) => (
  <div className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm">
    <div className={`w-12 h-12 rounded-2xl grid place-items-center mb-3 ${accent || "bg-brand/10 text-brand"}`}><Icon className="w-6 h-6" /></div>
    <div className="font-heading font-extrabold text-3xl text-ink">{value}</div>
    <div className="text-base text-ink-muted mt-1">{label}</div>
  </div>
);

const Dashboard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="grid place-items-center h-64"><Loader2 className="w-10 h-10 animate-spin text-brand" /></div>;

  return (
    <div>
      <h1 className="font-heading font-extrabold text-3xl text-ink mb-8">Tableau de bord</h1>
      <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-4">
        <Stat icon={CalendarCheck} label="Réservations aujourd'hui" value={d.bookings_today} />
        <Stat icon={Truck} label="Livraisons aujourd'hui" value={d.deliveries_today} accent="bg-accent2/10 text-accent2" />
        <Stat icon={Undo2} label="Récupérations aujourd'hui" value={d.returns_today} accent="bg-amber-100 text-amber-600" />
        <Stat icon={Bike} label="En location" value={d.in_rental} accent="bg-green-100 text-green-600" />
        <Stat icon={PackageCheck} label="Matériel disponible" value={`${d.available_units} / ${d.total_units}`} />
        <Stat icon={Euro} label="CA total" value={`${d.revenue.toFixed(0)} €`} accent="bg-green-100 text-green-600" />
        <Stat icon={TrendingUp} label="CA ce mois" value={`${d.revenue_month.toFixed(0)} €`} accent="bg-brand/10 text-brand" />
        <Stat icon={CalendarCheck} label="Réservations payées" value={`${d.paid_bookings} / ${d.total_bookings}`} />
      </div>

      <div className="grid gap-6 lg:grid-cols-2 mt-8">
        <div className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm">
          <h2 className="font-heading font-bold text-xl text-ink mb-4">Prochaines réservations</h2>
          {d.upcoming.length === 0 && <p className="text-ink-muted">Aucune réservation à venir.</p>}
          <div className="space-y-2">
            {d.upcoming.map((b) => (
              <div key={b.id} className="flex justify-between items-center py-2 border-b border-slate-50">
                <div><span className="font-semibold text-ink">{b.ref}</span> · {b.first_name} {b.last_name}</div>
                <span className="text-ink-muted">{b.start.slice(0, 10)}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm">
          <h2 className="font-heading font-bold text-xl text-ink mb-4">Livraisons du jour</h2>
          {d.deliveries_today_list.length === 0 && <p className="text-ink-muted">Aucune livraison aujourd'hui.</p>}
          <div className="space-y-2">
            {d.deliveries_today_list.map((b) => (
              <div key={b.id} className="flex justify-between py-2 border-b border-slate-50">
                <span className="font-semibold text-ink">{b.ref}</span><span className="text-ink-muted">{b.first_name} {b.last_name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
